module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-170.d9cdf08.woff2";